import React, { useState, useRef } from 'react';
import Card from "../components/Card";
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import CreateEditJobSurveyModal from "../modals/CreateEditJobSurveyModal";
import {toast} from "react-toastify";
import ArchiveJobSurveyModal from "../modals/ArchiveJobSurveyModal";
import {SURVEY_PAGES} from "../pages/JobSurveyPage";

const JobSurveyDataTable = (props) => {
    const {
        jobId,
        parentId,
        onChangePage    = (SHOW, survey) => {}
    } = props;

    const dataTableRef = useRef(null);

    const [createEditJobSurveyModal, setCreateEditJobSurveyModal]   = useState(false);
    const [archiveJobSurveyModal, setArchiveJobSurveyModal]         = useState(null);

    const renderNotes = (item) => {
        if (!item.notes || item.notes === "") {
            return "-";
        }

        return (
            <div className={"bespoke-tooltip"}>
                <div className={"tooltip-icon"}>
                    <i className="fa fa-sticky-note" />
                </div>
                <div className={"tooltip-text"}>
                    <span>{item.notes}</span>
                </div>
            </div>
        );
    }

    const renderRowButton = (survey) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!survey.can && (survey.can.view === true || survey.can.update === true || survey.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {!!survey.can.view === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => onChangePage(SURVEY_PAGES.SHOW, survey)}
                                    >
                                        <span>View Survey</span>
                                    </button>
                                )}
                                {!!survey.can.update === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setCreateEditJobSurveyModal(survey.id)}
                                    >
                                        <span>Edit Survey</span>
                                    </button>
                                )}
                                {!!survey.can.delete === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setArchiveJobSurveyModal({job: jobId, survey: survey.id})}
                                    >
                                        <span>Delete Survey</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card
                title={"Surveying Jobs"}
                classes={"mh-100 border-0"}
                controls={can('create', 'survey') ? (
                    <button onClick={(event) => {
                        event.preventDefault();
                        setCreateEditJobSurveyModal(true);
                    }} className={"btn font-weight-bold btn-eh-lilac px-4 m-0"}>
                        <i className={"far fa-plus-circle mr-2"} />
                        <span>{"Create Survey"}</span>
                    </button>
                ) : null}
            >
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.job.survey.data-table', {job: jobId}).toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="surveys" />}
                                fieldsToExclude={[
                                    'id',
                                    'deleted_at',
                                    'actioned_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    'created_at',
                                    'status',
                                ]}
                                fieldMap={{
                                    created_at: "Created Date",
                                    completed_at: "Date Completed",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'created_at'}
                                defaultOrderByDirection={'asc'}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'notes':
                                            return renderNotes(row);
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <CreateEditJobSurveyModal
                show={!!createEditJobSurveyModal}
                jobId={jobId}
                surveyId={!!createEditJobSurveyModal && createEditJobSurveyModal !== true ? createEditJobSurveyModal : null}
                parentId={parentId}
                onCancel={() => setCreateEditJobSurveyModal(null)}
                onComplete={(survey) => {
                    setCreateEditJobSurveyModal(null);
                    dataTableRef.current.reload();
                    toast.success(<div>{(createEditJobSurveyModal !== true && createEditJobSurveyModal !== false && createEditJobSurveyModal !== null) ? "Survey updated." : "Survey created."}</div>);
                }}
                onDelete={(survey) => {
                    setCreateEditJobSurveyModal(null);
                    dataTableRef.current.reload();
                    toast.success(<div>{"Survey deleted."}</div>);
                }}
            />
            <ArchiveJobSurveyModal
                show={!!archiveJobSurveyModal}
                jobId={!!archiveJobSurveyModal ? archiveJobSurveyModal.job : null}
                surveyId={!!archiveJobSurveyModal ? archiveJobSurveyModal.survey : null}
                parentId={parentId}
                onCancel={() => setArchiveJobSurveyModal(null)}
                onComplete={(survey) => {
                    setArchiveJobSurveyModal(null);
                    dataTableRef.current.reload();
                    toast.success(<div>{"Survey deleted."}</div>);
                }}
            />
        </React.Fragment>
    );
}

export default JobSurveyDataTable;
